module.exports = __webpack_public_path__ + "img/419.e42d9386.jpg";